import logo from '../logo.svg';
import '../App.css';
import { NavLink } from 'react-router-dom';
import { useContext, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { MessageContext } from '../context/MessageContext';
import { useSelector } from 'react-redux';

function Header({ mobileNav, setMobileNav }) {
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);
  const closeMobileNav = () => {
    setMobileNav(false);
    setOpenDropdown(null);
  };
  const { showMessage } = useContext(MessageContext);
  let user = null;

  try {
    const userData = localStorage.getItem("user");

    if (userData && userData !== "undefined") {
      user = JSON.parse(userData);
    } else {
      localStorage.removeItem("user");
    }

  } catch (error) {
    console.error("Invalid JSON in localStorage");
    localStorage.removeItem("user");
  }

  const handleLogout = () => {
    localStorage.removeItem("user");
    showMessage("User logout successfully", "success");
    navigate("/login");
  }

  const cartSelector = useSelector((state) => state.cart.items);
  return (
    <>
      <header id="header" className="header fixed-top">

        <div className="topbar d-flex align-items-center dark-background">
          <div className="container d-flex justify-content-center justify-content-md-between">

            <div className="contact-info d-flex align-items-center">
              <i className="bi bi-envelope d-flex align-items-center">
                <a href="mailto:contact@example.com">contact@example.com</a>
              </i>
              <i className="bi bi-phone d-flex align-items-center ms-4">
                <span>+1 5589 55488 55</span>
              </i>
            </div>

            <div className="d-flex align-items-center">
              {/* <div className="social-links d-none d-md-flex align-items-center me-3">
                <a href="#!" className="twitter"><i className="bi bi-twitter-x"></i></a>
                <a href="#!" className="facebook"><i className="bi bi-facebook"></i></a>
                <a href="#!" className="instagram"><i className="bi bi-instagram"></i></a>
                <a href="#!" className="linkedin"><i className="bi bi-linkedin"></i></a>
              </div> */}
              <nav id="navmenu" className="navmenu">
                <ul>
                  {user ? (
                    <li className={`dropdown ${openDropdown === "user" ? "dropdown-active" : ""}`}>
                      <a
                        href="#!"
                        className="d-flex align-items-center text-white fw-semibold"
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenDropdown(openDropdown === "user" ? null : "user");
                        }}
                      >
                        <i className="bi bi-person-circle me-2"></i>
                        <span>{user.name}</span>
                        <i className="bi bi-chevron-down toggle-dropdown ms-2"></i>
                      </a>

                      <ul className={openDropdown === "user" ? "dropdown-active" : ""}>
                        <li>
                          <NavLink to="/order" onClick={closeMobileNav}>
                            Order List
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/profile" onClick={closeMobileNav}>
                            Profile
                          </NavLink>
                        </li>
                        <li>
                          <a
                            href="#!"
                            className="text-danger"
                            onClick={handleLogout}
                          >
                            Logout
                          </a>
                        </li>
                      </ul>
                    </li>
                  ) : (
                    <li>
                      <NavLink to="/login" className="text-white fw-semibold">
                        <i className="bi bi-person-circle me-1"></i>
                        Login
                      </NavLink>
                    </li>
                  )}
                </ul>
              </nav>
            </div>

          </div>
        </div>

        <div className="branding d-flex align-items-cente">

          <div className="container position-relative d-flex align-items-center justify-content-between">
            <NavLink to="/" className="logo d-flex align-items-center">
              <h1 className="sitename">Clinic</h1>
            </NavLink>

            <nav id="navmenu" className="navmenu">
              <ul>
                <li>
                  <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMobileNav}>Home</NavLink></li>
                <li><NavLink to="/about" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMobileNav}>About</NavLink></li>
                <li><NavLink to="/departments" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMobileNav}>Departments</NavLink></li>
                <li><NavLink to="/services" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMobileNav}>Services</NavLink></li>
                <li><NavLink to="/doctors" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMobileNav}>Doctors</NavLink></li>
                <li><NavLink to="/medicine" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMobileNav}>Medicine</NavLink></li>
                <li className={`dropdown ${openDropdown === "pages" ? "dropdown-active" : ""}`}><a href="#" onClick={(e) => {
                  e.preventDefault();
                  setOpenDropdown(openDropdown === "pages" ? null : "pages");
                }}><span>More Pages</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul className={openDropdown === "pages" ? "dropdown-active" : ""}>
                    <li><NavLink to="/department-details" onClick={closeMobileNav}>Department Details</NavLink></li>
                    <li><NavLink to="/service-details" onClick={closeMobileNav}>Service Details</NavLink></li>
                    <li><NavLink to="/appointment" onClick={closeMobileNav}>Appointment</NavLink></li>
                    <li><NavLink to="/testimonials" onClick={closeMobileNav}>Testimonials</NavLink></li>
                    <li><NavLink to="/faq" onClick={closeMobileNav}>Frequently Asked Questions</NavLink></li>
                    <li><NavLink to="/gallery" onClick={closeMobileNav}>Gallery</NavLink></li>
                    <li><NavLink to="/terms" onClick={closeMobileNav}>Terms</NavLink></li>
                    <li><NavLink to="/privacy" onClick={closeMobileNav}>Privacy</NavLink></li>
                  </ul>
                </li>

                <li><NavLink to="/contact" onClick={closeMobileNav}>Contact</NavLink></li>
                <li><NavLink to="/cart" onClick={closeMobileNav}><span className="cart-icon">🛒</span>
                  {cartSelector.length ? <span className="cart-count">{cartSelector.length}</span> : ''}</NavLink></li>

              </ul>
              <i
                className={`mobile-nav-toggle d-xl-none bi ${mobileNav ? "bi-x" : "bi-list"}`}
                onClick={() => setMobileNav(!mobileNav)}
              ></i>
            </nav>

          </div>

        </div>

      </header>
    </>
  );
}

export default Header;
